import { render, staticRenderFns } from "./EleFormTextarea.vue?vue&type=template&id=cfbfded4&"
import script from "./EleFormTextarea.vue?vue&type=script&lang=js&"
export * from "./EleFormTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports